import {
  gql 
} from "@apollo/client"

export const ADD_TO_WISHLIST = gql`
    mutation AddProductToWishlistFromGallery(
        $wishlistId: ID!
        $itemOptions: WishlistItemInput!
        $productId: Int
    ) {
        addProductsToWishlist(
            wishlistId: $wishlistId
            wishlistItems: [$itemOptions]
        ) {
            user_errors {
                code
                message
            }
            wishlist {
                id
                items_v2(product_id: $productId) {
                    items {
                        id
                    }
                }
            }
        }
    }
`

export const GET_PRODUCTS_IN_WISHLISTS = gql`
    query GetProductsInWishlistsForGallery {
        customerWishlistProducts @client
    }
`
export const GET_PRODUCTS_IN_WISHLIST_INFOS = gql`
    query GetProductsInWishlistInfosForGallery {
        customerWishlistProductInfos @client
    }
`

export default {
  addProductToWishlistMutation: ADD_TO_WISHLIST,
  getProductsInWishlistsQuery: GET_PRODUCTS_IN_WISHLISTS,
}
